'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = EditorMsg;
var _react = _interopRequireDefault(require("react"));
var _bemit = _interopRequireDefault(require("Functions/bemit"));
function EditorMsg(_ref) {
  let {
    message,
    bemit: modifiers
  } = _ref;
  const output = /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _bemit.default)('c-text-editor-msg', modifiers)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "c-text-editor-msg__content"
  }, message));
  return output;
}
